import { useState } from 'react';
import { ModalActions } from '../../../components/PromptDialog';
import type { PublicationRow } from '../publishingApi';
import { PublishingDialog } from './PublishingDialog';
import { field } from './publishingUi';

export function ResolvePublication({
  row,
  error,
  busy,
  close,
  save,
}: {
  row: PublicationRow;
  error: string;
  busy: boolean;
  close: () => void;
  save: (input: { url: string; reason: string }) => Promise<void>;
}) {
  const removal = row.state === 'LIVE';
  const [url, setUrl] = useState(row.liveUrl ?? '');
  const [reason, setReason] = useState('');
  const [confirmed, setConfirmed] = useState(false);
  return (
    <PublishingDialog
      title={removal ? 'Veröffentlichung zurücknehmen' : 'Veröffentlichungslink bestätigen'}
      close={close}
      submit={() => void save({ url, reason })}
    >
      {error && (
        <p role="alert" className="mb-3 text-sm">
          {error}
        </p>
      )}
      <p className="mb-3 text-sm">{row.title}</p>
      {removal ? (
        <p className="mb-3 text-sm">
          Öffne den Beitrag auf der Plattform und lösche ihn dort. Hier dokumentierst du anschließend die
          Entfernung mit ihrem Grund.{' '}
          <a href={row.liveUrl ?? '#'} target="_blank" rel="noreferrer" className="underline">
            Beitrag öffnen ↗
          </a>
        </p>
      ) : (
        <label className="mb-3 block text-sm">
          Link zum veröffentlichten Video
          <input
            className={field}
            required
            type="url"
            value={url}
            disabled={busy}
            onChange={(e) => setUrl(e.target.value)}
          />
        </label>
      )}
      <label className="block text-sm">
        {removal ? 'Grund der Entfernung' : 'Wie wurde die Veröffentlichung geprüft?'}
        <textarea
          className={field}
          required
          minLength={8}
          maxLength={1000}
          value={reason}
          rows={3}
          disabled={busy}
          onChange={(e) => setReason(e.target.value)}
        />
      </label>
      <label className="mt-3 flex items-start gap-2 text-sm">
        <input
          type="checkbox"
          disabled={busy}
          checked={confirmed}
          onChange={(e) => setConfirmed(e.target.checked)}
        />
        {removal
          ? 'Ich habe den Beitrag auf der Plattform gelöscht.'
          : 'Ich habe geprüft, dass der Link genau dieses Video auf dem richtigen Konto zeigt.'}
      </label>
      <ModalActions
        onCancel={close}
        confirmLabel={removal ? 'Entfernung dokumentieren' : 'Als veröffentlicht bestätigen'}
        disabled={busy || !confirmed || reason.trim().length < 8 || !url}
      />
    </PublishingDialog>
  );
}
